import styled from '@emotion/styled';

export const RatingControllerLabel = styled('label', {
  shouldForwardProp: (prop) => prop !== 'isInvalid',
})((props) => ({
  color: props.isInvalid ? 'red' : 'inherit',
}));
